import React from 'react';

const Likert = ({ ...attrs }) => (
  <svg viewBox="0 0 64 32" {...attrs} width="1.3em">
    <g transform="translate(0 -15.837)">
      <g transform="rotate(60 117.87 176.56) translate(8 -37) scale(1.2)">
        <path
          style={{ fill: 'currentColor', strokeWidth: 2 }}
          d="m-40.8 182.1c-1.2 0.3-1.9 1.6-1.5 2.7 0.3 1.2 1.6 1.9 2.7 1.5 1.2-0.3 1.9-1.6 1.5-2.7-0.3-1.2-1.5-1.9-2.7-1.5zm0.2 0.7c0.8-0.2 1.6 0.2 1.8 1s-0.2 1.6-1 1.8-1.6-0.2-1.8-1 0.3-1.6 1-1.8z"
        />
        <path
          style={{ fill: 'currentColor', strokeWidth: 2 }}
          d="m-38.9 185.8 0.6 2c0.1 0.2-0.1 0.4-0.2 0.4l-1 0.3c-0.2 0.1-0.4-0.1-0.4-0.2l-0.6-2c-0.1-0.2 0.1-0.4 0.2-0.4l1-0.3c0.2-0.1 0.4 0 0.4 0.2z"
        />
        <path
          style={{ fill: 'currentColor', strokeWidth: 2 }}
          d="m-41.2 182.5-2.2-9.8 3.2 9.5z"
        />
      </g>

      <line
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        }}
        x1="19.9"
        x2="9.6"
        y1="36.1"
        y2="28.4"
      />
      <line
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        }}
        x1="27.1"
        x2="23.4"
        y1="30.4"
        y2="18.3"
      />
      <line
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        }}
        x1="36.8"
        x2="40.5"
        y1="30.4"
        y2="18.8"
      />
      <line
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        }}
        x1="44.3"
        x2="54.4"
        y1="35.8"
        y2="28.2"
      />
      <path
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        }}
        d="m16 45.2c1.8-8.8 8.3-15.3 16.1-15.3s14.3 6.5 16.1 15.3h12.9c-1.1-15.8-13.7-28.2-29.1-28.2s-28 12.4-29.1 28.2z"
      />
    </g>
  </svg>
);

export default Likert;
